<div><dl class="uk-description-list"><dt>{{ label }}</dt><dd :class="{ code: code }">{{ value }}</dd></dl></div>